//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { EventsNames } from '../../../../helpers/events-names'
import { CreateEditPopupOptions } from '../../../common/create-edit-popup/create-edit-popup.directive'
import { Enums } from '../../../../models/common/enums'
import { IOpObject } from '../../../../models/util/interfaces'
import { LocationService } from '../../../../services/location'
import { OpDataTypeInGroup, OpDataType, OpDataTypeGroup } from '../../../../models/core'
import { LocalizationHelper, LogHelper } from '../../../../helpers'
import { ConfirmationSource } from '../../../common/confirmation-popup/confirmation-popup.directive'
import { InfoPopupSource } from '../../../common/info-popup/info-popup.directive'
import { CreateEditSection } from '../../../common/common.create-edit'
import { CreateEditController, CreateEditScope } from '../../../common/common.create-edit.controller'
import { UserSessionService } from '../../../../services/user-session'
import { DataTypeGroupConfigurationFormPecGliwiceInitParams } from '../pec-gliwice-configuration-form.interfaces'
import { DataTypeGroupService } from '../../../../services/data-type-group'

interface PecGliwiceCreateEditScope extends CreateEditScope {
    options: CreateEditPopupOptions

    confirmSaveLocationSource: ConfirmationSource
    warningId: number
    needInfoPopup: boolean
    infoPopupSource: InfoPopupSource
    actionsId: number
    confirmSendActionsSource: ConfirmationSource

    confirmChangesText: string
    noText: string

    needActionRun: boolean
}

const OPEN_POPUP_EVENT_NAME: string = `${Enums.SimaxDedicatedCreateEditForm.PECGLIWICE.replace(/-/gi, '_').toUpperCase()}_OPEN_POPUP`

export class PecGliwiceDataTypeGroupCreateEditController
    extends CreateEditController {

    // Consts

    private static get LOG_STRING(): string { return '[SIMAX.DataTypegroup.PecGliwiceDataTypeGroupCreateEditDirective] - %s' }

    // Consts End

    // Members

    private referenceValue: OpDataTypeGroup

    // Members End

    constructor(
        private $scope: PecGliwiceCreateEditScope,
        private $q: ng.IQService,
        private readonly userSession: UserSessionService,
        protected readonly referenctType: Enums.ReferenceType,
        private readonly moduleName: Enums.SimaxModuleName,
        private readonly dataTypeGroupService: DataTypeGroupService,
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // Events        

    private onInit(args: any[]): void {
        if (_.size(args) > 0) {
            const createEditInitParams: DataTypeGroupConfigurationFormPecGliwiceInitParams = args[0]

            this.referenceValue = createEditInitParams ? <OpDataTypeGroup>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP)

            if (this.referenceValue != null && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            const formSection: CreateEditSection = _.find(createEditInitParams.sections, (section: CreateEditSection) => section.type === 'form')

            const dataTypePromise: JQueryDeferred<void> = $.Deferred<void>()
            if (formSection != null && !(this.referenceValue != null && this.referenceValue.idObject > 0)) {
                this.userSession
                    .getDataProvider()
                    .DataType
                    .getDataTypes([Enums.DataType.HELPER_PARENT_ID_REFERENCE_TYPE, Enums.DataType.HELPER_PARENT_REFERENCE_VALUE])
                    .then((dataTypes: OpDataType[]) => {
                        _.forEach(dataTypes, (dt: OpDataType) => {
                            const dataTypeToAdd: OpDataTypeInGroup = new OpDataTypeInGroup()
                            dataTypeToAdd.idDataType = dt.idDataType
                            dataTypeToAdd.dataType = dt
                            formSection.dataTypesToEdit.push(dataTypeToAdd)
                        })

                        dataTypePromise.resolve()
                    })
            } else {
                dataTypePromise.resolve()
            }

            dataTypePromise.then(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP_DATA_TYPE_GROUP_PEC_GLIWICE, createEditInitParams)
            })
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const defer: ng.IDeferred<IOpObject> = this.$q.defer()
        const dataTypeGroup: OpDataTypeGroup = OpDataTypeGroup.fromIOpObject(objectToSave)

        if (dataTypeGroup.idDataTypeGroupType == null) {
            dataTypeGroup.idDataTypeGroupType = 1
        }

        this.dataTypeGroupService
            .saveDataTypeGroup(dataTypeGroup)
            .then((savedObject: OpDataTypeGroup) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                defer.resolve(savedObject)
            })
            .fail((error: any) => {
                LogHelper.error(PecGliwiceDataTypeGroupCreateEditController.LOG_STRING, error)
                this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                defer.reject()
            })

        return defer.promise
    }

    // Events End

    // Setup

    private setEvents(): void {
        this.$scope.$on(
            OPEN_POPUP_EVENT_NAME,
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )
    }

    private setOptions(): void {
        this.$scope.noText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.No)
        this.$scope.confirmChangesText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)

        this.$scope.options = {
            onSubmit: null,
            onClose: null,
            referenceType: LocationService.REFERENCE_TYPE,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: '',
            type: null,
            onBulkSave: null,
            onSave: (objectToSave: IOpObject): ng.IPromise<IOpObject> => this.onSave(objectToSave),
        }
    }

    // Setup End

    //#region Custom methods 

    //#endregion
}